var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26516 5.51516C5.11872 5.66161 4.88128 5.66161 4.73484 5.51516L0.234835 1.01516C0.0883889 0.868718 0.0883889 0.631281 0.234835 0.484834C0.381282 0.338388 0.618719 0.338388 0.765166 0.484834L5 4.71967L9.23484 0.484835C9.38128 0.338388 9.61872 0.338388 9.76517 0.484835C9.91161 0.631281 9.91161 0.868719 9.76517 1.01516L5.26516 5.51516Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.169c65d67d99f4202a7901432c11f889.svg";
export { ForwardRef as ReactComponent };